import React, { useMemo } from "react";
import { BrowserRouter, Routes, Route, Navigate, } from "react-router-dom";
import Context from "../app_context/Context";
import ContextState from "../app_context/ContextState";
import AppMain from "../pages/app_main/AppMain";
import Home from "../pages/home/Page";
import AuthenOTP from "../pages/authen_otp/Page";
import CustomerList from "../pages/customer_list/Page";
import WheelGamePlay from "../pages/wheel_game_play/Page";

export default function RootRoutes(props) {
  const store = { ...ContextState() };

  let url_schema = [
    { icon: "fa-solid fa-warehouse", title: "หน้าแรก", path: '/home', element: <CustomerList /> },
    { icon: "fa-solid fa-warehouse", title: "ยืนยันตัวตน", path: '/authentication', element: <AuthenOTP /> },
    { icon: "fa-solid fa-warehouse", title: "เล่นเกมวงล้อ", path: '/wheel-game-play/:CUSTCODE', element: <WheelGamePlay /> },

  ]
  return (
    <Context.Provider value={store}>
      <BrowserRouter basename="/mk-rewards">
        <Routes>
          <Route path="/" element={<AppMain url_schema={url_schema} />}>
            {url_schema.map((item, index) =>
              <Route key={item.path} path={item.path} element={item.element} />
            )}

            <Route path="/*" element={<CustomerList />} />

          </Route>
          {/* <Route path="/Login" element={<Login />} /> */}
          {/* <Route path="/*" element={<PageNotFound />} /> */}
        </Routes>
      </BrowserRouter>
    </Context.Provider>
  );
}

